













import Vue from "vue";
import VelloIcon from "@/components/vue-components/VelloIcon.vue";
import { mapGetters } from "vuex";

/**
 * This view is intended to be put in an iframe and closed automatically.
 * It simply sends a message to parent saying that the Stripe setup intent is complete.
 * 'parent' is a reference to the dialog in backbone that this view lives in.
 */

export default Vue.extend({
  name: "PaymentMethodRedirect",
  components: { VelloIcon },
  computed: {
    ...mapGetters(["GET_CSRF_INFORMATION"])
  },
  created() {
    parent.postMessage("payment-method-complete", "*");
  }
});
